import React from 'react';
import { OptionsMonetaryText } from './OptionsMonetaryText';

export const OptionsValuePair = ({
  primary,
  secondary = null,
  primaryToneClass = 'text-white',
  secondaryToneClass = 'text-white/55',
  primarySizeClassName = 'text-lg',
  testId,
}) => {
  return (
    <div data-testid={testId}>
      <p className={`mt-2 font-bold tabular-nums ${primarySizeClassName} ${primaryToneClass}`} data-testid={`${testId}-primary`}>
        <OptionsMonetaryText value={primary} />
      </p>
      {secondary ? (
        <p className={`mt-1 text-sm tabular-nums ${secondaryToneClass}`} data-testid={`${testId}-secondary`}>
          <OptionsMonetaryText value={secondary} iconSize={14} />
        </p>
      ) : null}
    </div>
  );
};

export default OptionsValuePair;